<template>
  <section class="about-top">
    <div class="about-top__content">
      <div class="about-top__picture-container">
        <picture class="about-top__picture">
          <source
            :srcset="BulkOrderTitleImageForSp"
            alt="大人数に配りたい時はまとめてオーダー"
            media="(max-width: 767px)"
          />
          <img
            :src="BulkOrderTitleImage"
            alt="大人数に配りたい時はまとめてオーダー"
          />
        </picture>
      </div>
    </div>
  </section>
</template>

<script setup>
import BulkOrderTitleImage from '../../../../../../images/bulk_personal_orders/about/bulk_order_title.png'
import BulkOrderTitleImageForSp from '../../../../../../images/bulk_personal_orders/about/bulk_order_title_for_sp.png'
</script>

<style lang="scss" scoped>
.about-top {
  background-color: $primary-lighten;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  &__content {
    display: flex;
    max-width: 1440px;
    width: 100%;
    padding: 88px 110px;
    gap: 43px;
    align-items: center;
    justify-content: center;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 34px 84px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 18px 58px;
    }
  }

  &__picture-container {
    width: 100%;
    aspect-ratio: 2702 / 574;

    @media (max-width: 767px) {
      aspect-ratio: 1500 / 1051;
    }
  }

  &__picture {
    width: 100%;
    height: 100%;
    display: block;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
  }
}
</style>
